import { Controller } from '@hotwired/stimulus';
import Tracking from '../../components/tracking';

/**
 * @param eventName this is mandatory without it the tracking won't work
 * @param trackClickOnce
 * @param eventProperties format in slim { "test": "123", "test2": "456" } which is a json format
 */
export default class extends Controller {
  static values = {
    eventName: String,
    trackClickOnce: Boolean,
    eventProperties: Object,
  };

  connect() {
    this.clicked = false;
  }

  trackAmplitude() {
    if ((this.clicked && this.trackClickOnceValue) || !this.eventNameValue || this.eventNameValue.length === 0) return;
    Tracking.amplitudeTracking(this.eventNameValue, this.eventPropertiesValue, () => { this.clicked = true; });
  }

  trackGA() {
    if ((this.clicked && this.trackClickOnceValue) || !this.eventNameValue || this.eventNameValue.length === 0) return;
    Tracking.trackGA(this.eventNameValue, this.eventPropertiesValue);
  }
}
